<template>
  <div class="lawdetmorexg">
    <div class="title">更多量刑相关知识</div>
    <div class="xgatclist">
      <div class="item" v-for="item in 4" :key="item">
        <div class="xgatctit">掩饰隐瞒犯罪所得罪立案及量刑标准</div>
        <div class="xgatcinfo flex_start">
          <div class="cover">
            <img src="../../../assets/laws/lawdetcover_sample.png" alt="" />
          </div>
          <div class="textms">
            <div>
              {{
                `该罪名的全称为“掩饰、隐瞒犯罪所得、犯罪所得收益罪”;2007年5月9日最高人民法院、最高人民检察院出台的《关于办理盗窃、抢劫、诈骗、抢夺机动车相关刑事案件具体应用法律若干问题的解释》法释(2007)11号中进一步明确了“掩饰、隐瞒犯罪所得`
                  | toEllipsisFilter(120)
              }}
            </div>
            <div class="botom flex_start">
              <div class="le">
                <svg-icon icon-class="time" />
                <span>2021-04-23</span>
              </div>
              <div>
                <img src="../../../assets/laws/huo.png" alt="" />
                <span>11111</span>人看过
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.lawdetmorexg {
  padding: 24px 22px;
  .title {
    font-size: 24px;
    color: #333333;
    line-height: 24px;
  }
  .xgatclist {
    padding: 6px 0;
    .item {
      padding: 24px 0;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      .xgatctit {
        font-size: 18px;
        color: #333333;
        line-height: 18px;
      }
      .xgatcinfo {
        margin-top: 25px;
        position: relative;
        align-items: flex-start;
        .cover {
          margin-right: 23px;
          img {
            width: 212px;
            height: 130px;
          }
        }
        .textms {
          font-size: 14px;
          color: #666666;
          line-height: 30px;
          .botom {
            position: absolute;
            bottom: 10px;
            line-height: 16px;
            .svg-icon,
            img {
              vertical-align: -0.15em;
              margin-right: 7px;
            }
            .le {
              padding-right: 21px;
              margin-right: 21px;
              border-right: 1px solid #eee;
            }
          }
        }
      }
      
      &:hover {
        .xgatctit {
          color: #0465ea;
        }
      }
      &:last-child{
      border-bottom: none;
      padding-bottom: 0;
      }
    }
  }
}
</style>